module.exports = __webpack_public_path__ + "img/gamma3ex_icon.d316db53.png";